import { useEffect, useState } from "react";
import { Download, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { isNative } from "@/lib/native";

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallButton({ className = "" }) {
  const [deferred, setDeferred] = useState(null);
  const [iosHelp, setIosHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (isNative() || installed || (!deferred && !isIOS())) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setInstalled(true);
      setDeferred(null);
    } else setIosHelp(true);
  };

  return (
    <>
      <button type="button" data-testid="install-app-btn" onClick={install} className={`flex items-center justify-center gap-2 text-xs font-semibold text-stellar bg-void hover:shadow-stellar-glow border border-stellar/30 rounded-secure px-3 py-2 transition-colors ${className}`}>
        <Download className="w-3.5 h-3.5" /> Install app
      </button>
      <Dialog open={iosHelp} onOpenChange={setIosHelp}>
        <DialogContent data-testid="install-ios-dialog" className="bg-nebula border-rim text-ash sm:max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-branding">Install Aphelion</DialogTitle>
            <DialogDescription className="text-ash/55">Add Aphelion to your Home Screen in two taps.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Share className="w-5 h-5 text-stellar" /> Tap the <b>Share</b> button in Safari</li>
            <li className="flex items-center gap-3"><PlusSquare className="w-5 h-5 text-stellar" /> Choose <b>Add to Home Screen</b></li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
